import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.scss";
import "./styles/tailwind.css";
import App from "./App";
import { MantineProvider } from "@mantine/core";
import { UserProvider } from "./contexts";
import { Auth, Storage, API } from "aws-amplify";
import config from "./aws-exports";
import { theme } from "./config/theme";
import "./i18n";
import { Helmet } from "react-helmet";
import { initSentry } from "./sentry";

// Initialize Sentry error tracking before anything else
initSentry();

Auth.configure(config);
API.configure(config);
Storage.configure(config);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Helmet>
      <script
        async
        type="text/javascript"
        src="https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/d25e20f0ac7f44f6942494d31af7267f5852ab39f29c4f8d83f610f27aac7fdf.js"
      ></script>
    </Helmet>
    <MantineProvider theme={theme}>
      <UserProvider>
        <App />
      </UserProvider>
    </MantineProvider>
  </React.StrictMode>,
);
